<template>
<div>
    <Breadcrumbs main="Procurement" title="RFP Create" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title <span style="color: red;">*</span></label>
                                        <input class="form-control" type="text" placeholder="Enter rfp title" v-model="rfp.title">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Category <span style="color: red;">*</span></label>
                                        <select class="form-control digits" v-model="rfp.rfp_category">
                                            <option v-for="(item, index) in items" :key="index" :value="item.id">{{ item.title }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <select class="form-control digits" v-model="rfp.status">
                                            <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Deadline</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="rfp.deadline"></datepicker>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-sm-6" v-if="this.$route.params.project !== 'new'">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="rfp.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select
                                            disabled
                                            class="custom-vue-select"
                                            :options="projects"
                                            label="title"
                                            :reduce="project => project.id"
                                            v-model="rfp.project"
                                            placeholder="Select a project"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6" v-else>
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="rfp.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select
                                            class="custom-vue-select"
                                            :options="projects"
                                            label="title"
                                            :reduce="project => project.id"
                                            v-model="rfp.project"
                                            placeholder="Select a project"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <!-- <button class="btn-success ml-3" @click="selectAll = !selectAll">Select All</button> -->
                                        <div style="display: flex;">
                                            <label>Vendor</label>
                                            <input class="ml-2 mb-2" type="checkbox" id="myCheck" v-model="selectAll" @click="selectAll = !selectAll"> <span class="ml-2" v-if="selectAll">All vendors selected.</span>
                                        </div>
                                        <multiselect v-model="assignedVendor" tag-placeholder="Add member" placeholder="Search or add a member" label="user" :max="vendor_list.length" track-by="id" :options="formattedVendorOptions" :multiple="true" :taggable="true" :disabled="selectAll"></multiselect>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="rfp.rfp_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Short Description <span style="color: red;">*</span></label>
                                        <!-- <textarea class="form-control" id="textarea-auto-height" placeholder="Enter short description..." rows="5" max-rows="8" v-model="rfp.details"></textarea>  -->
                                        <!-- <ckeditor :editor="editor" placeholder="Enter short description..." v-model="rfp.details"></ckeditor> -->
                                        <vue-editor  v-model="rfp.details"></vue-editor>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                        <router-link to="/procurement/rfp/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import treeVue from '../../advance/tree.vue';
import { VueEditor } from "vue2-editor";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        VueEditor,
        'v-select': vSelect
    },

    data() {
        return {
            isDisabled:false,
            editor: ClassicEditor,
            rfp: {
                title: '',
                status: 'INITIATED',
                project:null,
                priority: 'HIGH',
                rfp_category: null,
                deadline: null,
                details: '',
                rfp_attachment: null
            },
            vendor_id: null,
            assignedVendor: [],
            selectAll: false,

            statuses: ['INITIATED', 'APPROVED', 'WORKING', 'COMPLETED']
        };
    },

    computed: {
        ...mapState({
            items: state => state.rfp.rfp_category,
            vendor_list: state => state.vendor.vendor_without_pg,
            projects: state => state.project.project,
        }),
        formattedVendorOptions() {
            return this.vendor_list.map(vendor => ({
                id: vendor.user.id,
                user: vendor.user.user_name
            }));
        },
    },

    mounted() {
        this.$store.dispatch("rfp/fetchRFPCategory")
        this.$store.dispatch("vendor/fetchVendor_without_pg")
        this.$store.dispatch("project/fetchProject");

        if (this.$route.params.id === 'new') {
            this.rfp.project = ''
        } else {
            this.rfp.project = Number(this.$route.params.id)
        }
    },

    methods: {
        uploadFile(e) {
            this.rfp.rfp_attachment = e.target.files[0]
        },

        onSubmit() {
            this.isDisabled = true
            if (this.rfp.deadline !== null) {
                this.rfp.deadline = moment(String(this.rfp.deadline)).format("YYYY-MM-DD");
            }

            if (this.selectAll == true) {
                this.vendor_id = null
            } else {
                if (!Array.isArray(this.vendor_id)) {
                    this.vendor_id = [];
                }
                this.assignedVendor.map(item => this.vendor_id.push(item.id));
            }

            this.rfp.title = this.rfp.title.trim() ? this.rfp.title : null;
            this.rfp.details = this.rfp.details.trim() ? this.rfp.details : null;

            if(this.rfp.title && this.rfp.details && this.rfp.rfp_category) {
                this.$store.dispatch("rfp/addRFP", {rfp:this.rfp, vendors:this.vendor_id}).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.rfp.title = '',
                        this.rfp.details = '',
                        this.rfp.rfp_category = null,
                        this.rfp.deadline = null,
                        this.rfp.priority = 'HIGH',
                        this.rfp.status = 'APPROVED',
                        this.rfp.rfp_attachment = null
                        this.vendor_id = null,
                        this.assignedVendor = [],
                        this.selectAll = false

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }

                    this.assignedVendor = []
                })
            } else {
                this.rfp.title = '',
                this.rfp.details = '',
                this.rfp.rfp_category = null,
                this.rfp.deadline = null,
                this.rfp.priority = 'HIGH',
                this.rfp.status = 'APPROVED',
                this.rfp.rfp_attachment = null

                Swal.fire({
                    title: "Error!",
                    text: 'You must enter all the mandatory fields (*)',
                    icon: "error"
                });
            }

            this.isDisabled = false
        }
    }
};
</script>
